import { useState, useEffect, useMemo } from 'react'
import B2BApiService from "../../B2bApiService";
import { Select, Text, TextArea } from "../formComponents/Inputs";
import { findIndustryBySelectValue, validateField } from '../../Utilities';
import { localizeIndustryList, t } from '../../content';
import { useLocale } from '../../locale';

function TeamReviewGeneral({ data, updateData }) {
    const { locale } = useLocale();

    let [jobIndustries, setJobIndustries] = useState([]);
    const departmentOptions = useMemo(
        () => localizeIndustryList(jobIndustries, locale),
        [jobIndustries, locale]
    );

    const b2bServiceObj = useMemo(() => {
        return new B2BApiService();
    }, []);

    useEffect(() => {
        b2bServiceObj.LoadIndustriesList(setJobIndustries);
    }, [b2bServiceObj, setJobIndustries]);
    const handleChange = (value, key) => {
        // For industry
        if (key === 'industry') {
            const match = findIndustryBySelectValue(jobIndustries, value);
            if (match) {
                updateData({ ...data, industry: match });
            }
            return;
        }
        updateData({ ...data, [key]: value });
    }

    return (        
        <>
            <div className="title-and-target-profile section">
                <div className="title">
                    <div className="field-label">{t('teams.teamName')} <span className="mandatory">*</span></div>
                    <Text
                        title=''
                        required={true}
                        fullWidth={true}
                        doValidation={validateField("text", data?.title).isValid}
                        errorContent={t('validation.enterTeamName')}
                        handleChange={e => handleChange(e.target.value, 'title')}
                        value={data?.title || ''}
                    />
                </div>
                <div className="department">
                    <div className="field-label">{t('recruitment.form.department')}<span className="mandatory">*</span></div>
                    <Select
                        id={'industry'}
                        label={t('teams.departmentsList')}
                        options={departmentOptions}
                        doValidation={validateField("number", data?.industry).isValid}
                        errorContent={t('validation.selectDepartment')}
                        handleChange={e => handleChange(e.target.value, 'industry')}
                        option={data?.industry?.id ?? ''}
                        defaultValue={t('teams.selectJobDepartment')}
                    />
                </div>
            </div>

            <div className="description">
                <div className="field-label">{t('recruitment.form.jobDescription')}</div>
                <TextArea
                    title=''
                    required={false}
                    fullWidth={true}
                    handleChange={e => handleChange(e.target.value, 'description')}
                    value={data?.description || ''}
                />
            </div>
        </>
    )
}

export default TeamReviewGeneral





